import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ScheduledEmailList } from './scheduled-email.model';

/**
 * TVG-359: read-only wrapper for the contact's queued emails.
 *
 * The list endpoint is TVG-335's and is not changed here. Only the GET is
 * exposed: the cancel action exists on the server but this panel is a window,
 * not a control panel, so nothing in the browser can reach it through here.
 */
@Injectable({
  providedIn: 'root',
})
export class ScheduledEmailService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  listForContact(contactId: number | string): Observable<ScheduledEmailList> {
    return this.http.get<ScheduledEmailList>(
      `${this.apiUrl}/api/contacts/${contactId}/scheduled-emails`,
    );
  }
}
